export const MESSAGE_WITH_QUESTION_QUERY = {
    question: true,
};